export enum EditPolicyAssignmentEvents {
  CLICK_ON_SAVE = 'clickOnSave',
}

export interface Dependencies {
  api: {
    type: string;
  };
  translateFn: Function;
}

export interface PoliciesSelector {
  moduleAndSection: PolicyModuleAndSection,
  excludeInheritedPolicies: boolean,
  selectedPolicies: string[],
}

export interface PolicyModuleAndSection {
  moduleId: string;
  sectionId: string;
}
